import styled from 'styled-components';
import {
  Link,
} from 'react-router';
import {
  Flex,
} from 'web-styled';

export const Navigation = styled(Flex).attrs({
  justify: 'space-between',
  align: 'center',
  shrink: 0,
})`
  width: 100%;
  padding: 15px;
  font-size: 14px;
  box-shadow: 0px 5px 10px -8px #8f8f8f;
  border-bottom: 1px solid rgba(40,45,48,0.1);
`;

export const Date = styled(Flex).attrs({
  align: 'center',
  spacing: 5,
})`
  color: ${props => props.theme.colors.primary};
  margin-right: 10px !important;
`;

const NavLink = styled(Link)`
  color: ${props => props.theme.colors.primary};
  padding: 9px 12px;
  border: 1px solid #e6e6e6;
  display: flex;
  align-items: center;

  &:hover,
  &:focus {
    z-index: 2;
    color: #23527c;
    background-color: #eee;
    border-color: #ddd;
  }
`;

export const NavPrev = styled(NavLink)`
  border-top-left-radius: 50px;
  border-bottom-left-radius: 50px;
`;

export const NavNext = styled(NavLink)`
  border-top-right-radius: 50px;
  border-bottom-right-radius: 50px;
`;

export const A = styled.a`
  color: ${props => props.theme.colors.primary};
  display: flex;
  align-items: center;
`;
